"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-bind */
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var DirectionRight_1 = require("../Icons/DirectionRight");
var select_1 = tslib_1.__importDefault(require("../select"));
var Panel_1 = tslib_1.__importDefault(require("./Panel"));
var utils_1 = require("./utils");
var CascaderSingleSelect = function (props) {
    var dataSource = props.dataSource, _a = props.selectedKeys, selectedKeys = _a === void 0 ? [] : _a, onChange = props.onChange, className = props.className, hasFilter = props.hasFilter, titles = props.titles, disabled = props.disabled, _b = props.size, size = _b === void 0 ? 'middle' : _b, error = props.error, _c = props.style, style = _c === void 0 ? {} : _c, _d = props.lastPanelStyle, lastPanelStyle = _d === void 0 ? {} : _d, _e = props.placement, placement = _e === void 0 ? 'bottomLeft' : _e, renderCell = props.renderCell, rest = tslib_1.__rest(props, ["dataSource", "selectedKeys", "onChange", "className", "hasFilter", "titles", "disabled", "size", "error", "style", "lastPanelStyle", "placement", "renderCell"]);
    var _f = tslib_1.__read((0, react_1.useState)(selectedKeys), 2), depSelectedKeys = _f[0], setDepSelectedKeys = _f[1];
    var _g = tslib_1.__read((0, react_1.useState)(dataSource), 2), depDataSource = _g[0], setDepDataSource = _g[1];
    var _h = tslib_1.__read((0, react_1.useState)([]), 2), cacheSelectedKeys = _h[0], setCacheSelectedKeys = _h[1];
    var _j = tslib_1.__read((0, react_1.useState)([]), 2), cacheDataSource = _j[0], setCacheDataSource = _j[1];
    var ref = (0, react_1.useRef)();
    var isNotTailRef = (0, react_1.useRef)(true);
    var selectedTitle = (0, react_1.useMemo)(function () {
        var _a;
        var map = (0, utils_1.generateMap)(cacheDataSource);
        var value = (_a = cacheSelectedKeys === null || cacheSelectedKeys === void 0 ? void 0 : cacheSelectedKeys.map(function (key) { var _a; return ((_a = map[key]) === null || _a === void 0 ? void 0 : _a.title) || key; })) === null || _a === void 0 ? void 0 : _a.reduce(function (pr, cur) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                pr,
                pr && (react_1.default.createElement(DirectionRight_1.DirectionRight, { className: "anq-cascader-select-title-icon anq-cascader-select-title-icon-".concat(size), style: {
                        verticalAlign: '-3px',
                    } })),
                cur));
        }, '');
        return value ? [{ key: 0, label: value }] : [];
    }, [cacheSelectedKeys, cacheDataSource, size]);
    var reverseTitles = (0, react_1.useMemo)(function () {
        return (titles || []).reverse();
    }, []);
    var depth = (0, react_1.useMemo)(function () {
        return (0, utils_1.getDataDepth)(dataSource);
    }, [dataSource]);
    var onFocus = function (selectKey) {
        var focusKeys = [];
        var dataSource = (0, cloneDeep_1.default)(depDataSource);
        var loop = function (dataSource) {
            var isSibling = dataSource.some(function (item) { return (item === null || item === void 0 ? void 0 : item.key) === selectKey; });
            dataSource.forEach(function (element) {
                var key = element.key, children = element.children, isFocus = element.isFocus;
                if (!isSibling) {
                    if (isFocus) {
                        focusKeys.push(key);
                        children && loop(children);
                    }
                }
                else {
                    if (key === selectKey) {
                        element.isFocus = true;
                        focusKeys.push(key);
                        if (!children) {
                            isNotTailRef.current = false;
                        }
                    }
                    else {
                        element.isFocus = false;
                    }
                }
            });
        };
        loop(dataSource);
        setDepSelectedKeys(focusKeys);
        setDepDataSource(dataSource);
        if (!isNotTailRef.current) {
            setCacheDataSource((0, cloneDeep_1.default)(dataSource));
            setCacheSelectedKeys((0, cloneDeep_1.default)(focusKeys));
            ref.current.blur();
            onChange && onChange(focusKeys);
        }
    };
    var getExpandable = function (depth) {
        return depth > 0
            ? {
                expandedRowRender: function (dataSource, parentRecord) {
                    if ((!dataSource || dataSource.length === 0) && !(parentRecord === null || parentRecord === void 0 ? void 0 : parentRecord.loadChildren)) {
                        return react_1.default.createElement(react_1.default.Fragment, null);
                    }
                    return (react_1.default.createElement(Panel_1.default, { hasFilter: hasFilter, title: reverseTitles[depth - 1], hideTitle: !reverseTitles[depth - 1], dataSource: dataSource, className: className, lastPanelStyle: lastPanelStyle, singleSelect: true, rowSelection: {
                            focusKeys: depSelectedKeys,
                            renderCell: renderCell,
                        }, onFocus: onFocus, expandable: getExpandable(depth - 1), parentRecord: parentRecord }));
                },
            }
            : undefined;
    };
    var onClear = (0, react_1.useCallback)(function () {
        setDepSelectedKeys([]);
        onChange && onChange([]);
    }, []);
    var onDropdownVisibleChange = (0, react_1.useCallback)(function (value) {
        // 没有选中项的情况下关闭dropdown时，回复默认项
        if (!value && isNotTailRef.current) {
            var timer_1 = null;
            timer_1 = setTimeout(function () {
                setDepSelectedKeys([]);
                timer_1 && clearTimeout(timer_1);
            }, 500);
        }
        isNotTailRef.current = value;
    }, []);
    (0, react_1.useEffect)(function () {
        if (selectedKeys.join(',') !== depSelectedKeys.join(',')) {
            var depDataSource_1 = (0, cloneDeep_1.default)(dataSource);
            var loop_1 = function (dataSource) {
                dataSource.forEach(function (element) {
                    var key = element.key, children = element.children;
                    element.isFocus = selectedKeys.includes(key);
                    if (element.loadChildren && !element.children) {
                        element.children = [];
                    }
                    children && loop_1(children);
                });
            };
            loop_1(depDataSource_1);
            setDepSelectedKeys(selectedKeys);
            setDepDataSource(depDataSource_1);
            setCacheDataSource((0, cloneDeep_1.default)(depDataSource_1));
            setCacheSelectedKeys((0, cloneDeep_1.default)(selectedKeys));
        }
    }, [selectedKeys]);
    (0, react_1.useEffect)(function () {
        var depDataSource = (0, cloneDeep_1.default)(dataSource);
        var loop = function (dataSource) {
            dataSource.forEach(function (element) {
                var key = element.key, children = element.children;
                element.isFocus = selectedKeys.includes(key);
                if (element.loadChildren && !element.children) {
                    element.children = [];
                }
                children && loop(children);
            });
        };
        loop(depDataSource);
        setDepSelectedKeys(selectedKeys);
        setDepDataSource(depDataSource);
        setCacheDataSource((0, cloneDeep_1.default)(depDataSource));
        setCacheSelectedKeys((0, cloneDeep_1.default)(selectedKeys));
    }, [dataSource]);
    return (react_1.default.createElement(select_1.default, tslib_1.__assign({ placeholder: "\u8BF7\u9009\u62E9", error: error, size: size, value: selectedTitle, labelInValue: true, className: "anq-select-cascader", dropdownClassName: "anq-select-cascader-dropdown", allowClear: depSelectedKeys.length > 0, onClear: onClear, dropdownStyle: { minWidth: 100 }, ref: ref, disabled: disabled, style: style, placement: placement, onDropdownVisibleChange: onDropdownVisibleChange }, rest, { dropdownRender: function () { return (react_1.default.createElement("div", { className: (0, classnames_1.default)('anq-cascader', className) },
            react_1.default.createElement("div", { className: "anq-selectable-container" },
                react_1.default.createElement(Panel_1.default, { hasFilter: hasFilter, title: reverseTitles[depth - 1], hideTitle: !reverseTitles[depth - 1], dataSource: depDataSource, className: className, lastPanelStyle: lastPanelStyle, singleSelect: true, rowSelection: {
                        focusKeys: depSelectedKeys,
                        renderCell: renderCell,
                    }, onFocus: onFocus, expandable: getExpandable(depth - 1), depth: 1 })))); } })));
};
exports.default = CascaderSingleSelect;
//# sourceMappingURL=SingleSelect.js.map